/**
 * Umami-Tracking.
 *
 * Das Script wird in index.html eingebunden. Dort ist bewusst kein
 * `data-do-not-track` gesetzt, damit Umami den DNT-Header ignoriert, und
 * `data-auto-track="false"`, damit Pageviews hier explizit gesendet werden
 * (siehe usePageviewTracking) und Admin-Routen ausgeschlossen bleiben.
 *
 * Es werden ausschließlich nicht-personenbezogene Daten gesendet:
 * niemals Namen, E-Mail-Adressen oder IBANs.
 */

// Browser-API des Umami-Trackers, siehe https://umami.is/docs/tracker-functions
declare global {
  interface Window {
    umami?: {
      track: (
        eventName?: string,
        eventData?: Record<string, string | number | boolean>,
      ) => void;
    };
  }
}

export const trackEvent = (
  eventName: string,
  eventData?: Record<string, string | number | boolean>,
): void => {
  // Kein Umami verfügbar (Dev-Umgebung, Adblocker, fremde Domain): still ignorieren.
  window.umami?.track(eventName, eventData);
};

export const trackPageview = (): void => {
  window.umami?.track();
};
